import React from 'react';
import './IndividualPsychotherapy.scss'

const IndividualPsychotherapy = () => {
  return (
    <section className='individual-psychotherapy'>
      <h1>Individual Psychotherapy</h1>
      Techniques used in sessions range from:
        <ul className='individual-psychotherapy__list'>
          <li className='individual-psychotherapy__list-item'>Psychodynamic</li>
          <li className='individual-psychotherapy__list-item'>Behavioral</li>
          <li className='individual-psychotherapy__list-item'>CBT</li>
          <li className='individual-psychotherapy__list-item'>Trauma Based CBT</li>
          <li className='individual-psychotherapy__list-item'>Family Systems</li>
          <li className='individual-psychotherapy__list-item'>Bibliotherapy</li>
          <li className='individual-psychotherapy__list-item'>Psychoeducation</li>
          <li className='individual-psychotherapy__list-item'>Solution Focused</li>
          <li className='individual-psychotherapy__list-item'>Crisis Therapy</li>
          <li className='individual-psychotherapy__list-item'>REBT</li>
          <li className='individual-psychotherapy__list-item'>Problem Solving Therapy</li>
        </ul>
        I help the client arrive to the mental clarity and health that they need in order to move forward and thrive in their lives. Sessions are conducted with quality, care with dignity and respect.
    </section>
  );
};

export default IndividualPsychotherapy;